/**
 * Dependencies.
 */
import { BaseModel, endpoint, lookup, prop } from '@prz-dp/services';

import { OwnerModel } from '@/api/detail/owner/owner.model';
import { SupervisorModel } from '@/api/detail/supervisor/supervisor.model';

/**
 * Export model `PartnershipModel`.
 */
@endpoint('partnerships')
export class PartnershipModel extends BaseModel {
  /**
   * Properties.
   */
  @prop()
  id: number;

  @prop()
  accountId: number;

  @prop()
  account?: {
    id: number;

    email: string;

    emailAccount?: string;

    photo?: string;
  };

  @prop()
  description: string;

  @prop()
  email: string;

  @prop()
  key: string;

  @prop()
  photo?: string;

  @prop()
  samAsset?: { url: string };

  @prop()
  userOwnerId: number;

  @lookup('userOwnerId', OwnerModel)
  owner!: OwnerModel;

  @prop()
  userSupervisorId: number;

  @lookup('userSupervisorId', SupervisorModel)
  supervisor!: SupervisorModel;

  @prop()
  membersAccess: boolean;

  @prop()
  canAccessFromBrowser: boolean;

  @prop()
  needsToAcceptTerms?: boolean;

  @prop()
  partnershipTeam?: { partnerTermsDocument?: string };

  /**
   * Constructor.
   */
  constructor(data?: Partial<PartnershipModel>) {
    super(data);
  }
}
